module.exports = __webpack_public_path__ + "static/images/solution.d5a6ca5b8a156af6b02d10983ed4324a.jpg";